export const API_URL = 'https://api.allmyfaves.com/api';

export const TURNSTILE_SITE_KEY = '0x4AAAAAACJ3_j-27ZLrU_sk';

export default API_URL;
